export default "__VITE_ASSET__3622a0aa__"